import { RemoteGetAllNomenclaturesFromEntity } from 'data/usecases';
import { makeApiUrlEntitiesNomenclatures } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllNomenclaturesFromEntity =
  (): RemoteGetAllNomenclaturesFromEntity => {
    return new RemoteGetAllNomenclaturesFromEntity(
      makeApiUrlEntitiesNomenclatures(),
      makeAxiosHttpClient(),
    );
  };
